import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Select from 'react-select'
import chroma from 'chroma-js'

const divStyle = {
  float: 'left',
  paddingLeft: '0px',
}

const aStyle = {
  display: 'none',
}

const spanStyle = {
  paddingLeft: '10px',
}

const options = [
  { value: '#FFFF00', label: 'Yellow' },
  { value: '#E67E22', label: 'Orange' },
  { value: '#800000', label: 'Maroon' },
  { value: '#008000', label: 'Green' },
  { value: '#0000FF', label: 'Blue' },
  { value: '#000080', label: 'Navy' },
  { value: '#800080', label: 'Purple' },
]

const options2 = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
]

const colourStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.value)
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? data.value
          : isFocused
            ? color.alpha(0.1).css()
            : null,
      color: isDisabled
        ? '#ccc'
        : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : 'black'
          : data.value,
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? data.value : color.alpha(0.3).css()),
      },
    }
  },
  input: styles => ({ ...styles, ...dot() }),
  placeholder: styles => ({ ...styles, ...dot() }),
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.value) }),
}

const dot = (color = '#ccc') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 8,
    height: 10,
    width: 10,
  },
})

function Checkbox(props) {
  return <Field name={props.name}>{({ field, form }) => <label><input type="checkbox" {...props} checked={field.value.includes(props.value)} onChange={() => {
              if (field.value.includes(props.value)) {
                const nextValue = field.value.filter(
                  value => value !== props.value
                )
                form.setFieldValue(props.name, nextValue)
              } else {
                const nextValue = field.value.concat(props.value)
                form.setFieldValue(props.name, nextValue)
              }
            }} /><span style={spanStyle}>{props.value}</span></label>}</Field>
}

function setCharAt(str, index, chr) {
  if (index > str.length - 1){
    return str
  }
  return str.substr(0, index) + chr + str.substr(index + 1)
}

const TeamForm = props => <Formik initialValues={{ name: props.team.name, description: props.team.description, color: props.team.color, weekdays: props.team.value_weekdays, oncall: props.team.oncall, id: '' }} enableReinitialize={true} validate={values => {
      const errors = {}
      const sel = document.getElementById('mycolor')
      values.color = sel.childNodes[1].value
      const sel2 = document.getElementById('myoncall')
      values.oncall = sel2.childNodes[1].value
      if (!values.name) {
        errors.name = 'Required'
      } else if (!values.color) {
        errors.color = 'Required'
      } else if (!values.description) {
        errors.description = 'Required'
      } else if (!values.oncall) {
        errors.oncall = 'Required'
      }
      return errors
    }} onSubmit={(values, { setSubmitting }) => {
      let body = ''
      let daysw = '0000000'
      if (values.weekdays.includes('Monday')){
        daysw = setCharAt(daysw, 0, '1')
      }
      if (values.weekdays.includes('Tuesday')){
        daysw = setCharAt(daysw, 1, '1')
      }
      if (values.weekdays.includes('Wednesday')){
        daysw = setCharAt(daysw, 2, '1')
      }
      if (values.weekdays.includes('Thursday')){
        daysw = setCharAt(daysw, 3, '1')
      }
      if (values.weekdays.includes('Friday')){
        daysw = setCharAt(daysw, 4, '1')
      }
      if (values.weekdays.includes('Saturday')){
        daysw = setCharAt(daysw, 5, '1')
      }
      if (values.weekdays.includes('Sunday')){
        daysw = setCharAt(daysw, 6, '1')
      }
      if (props.team.title === 'Create'){
        body = JSON.stringify({id: props.team.user_request, name: values.name, description: values.description, color: values.color, weekdays: daysw, oncall: values.oncall})
      } else {
        body = JSON.stringify({name: values.name, description: values.description, color: values.color, weekdays: daysw, oncall: values.oncall})
      }
      let urlf = '/api/v1/teams/'
      let meth = ''
      if (props.team.title === 'Create'){
        meth = 'POST'
      } else {
        meth = 'PATCH'
        urlf = urlf + props.team.id
      }
      fetch(urlf, {
        method: meth,
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      })
      .then(response => response.json())
      .then(() => {
        document.getElementById('mylink').click()
      })
      .catch((err) => {
        console.error('Error while adding team! ' + err)
      })
      setTimeout(() => {
        setSubmitting(false)
      }, 400)
    }}>{({ isSubmitting, errors}) => <Fragment><a href="/employee/teams" id="mylink" style={aStyle}></a><div className="row col-sm-12 justify-content-top"><h3>{props.team.title} team</h3></div><br /><Form><div className="row col-sm-12"><div className="col-sm-6" style={divStyle}><div><label htmlFor="name">Name</label><br /><Field type="text" name="name" className={'form-control' + (errors.name ? ' is-invalid' : '')}></Field></div><ErrorMessage name="name" component="div"></ErrorMessage><br /><div><label htmlFor="description">Description</label><br /><Field type="text" name="description" className={'form-control' + (errors.description ? ' is-invalid' : '')}></Field></div><ErrorMessage name="description" component="div"></ErrorMessage><br /><div><label htmlFor="oncall">Is this an OnCall Team?</label><br /><Select id="myoncall" name="oncall" options={options2} defaultValue={options2[props.team.index_oncall]}></Select></div><ErrorMessage name="oncall" component="div"></ErrorMessage><br /></div><div className="col-sm-6" style={divStyle}><div><label htmlFor="color">Color</label><br /><Select id="mycolor" name="color" options={options} styles={colourStyles} defaultValue={options[props.team.index_color]}></Select></div><ErrorMessage name="color" component="div"></ErrorMessage><br /><div><label htmlFor="weekdays">Weekdays</label><br /><div className="col-sm-4" style={divStyle}><Checkbox name="weekdays" value="Monday"></Checkbox><br /><Checkbox name="weekdays" value="Tuesday"></Checkbox><br /><Checkbox name="weekdays" value="Wednesday"></Checkbox></div><div className="col-sm-4" style={divStyle}><Checkbox name="weekdays" value="Thursday"></Checkbox><br /><Checkbox name="weekdays" value="Friday"></Checkbox></div><div className="col-sm-4" style={divStyle}><Checkbox name="weekdays" value="Saturday"></Checkbox><br /><Checkbox name="weekdays" value="Sunday"></Checkbox></div></div><ErrorMessage name="weekdays" component="div"></ErrorMessage><br /></div><button type="submit" disabled={isSubmitting}>{props.team.title} team</button><br /><br /></div></Form></Fragment>}</Formik>

TeamForm.propTypes = {
  team: PropTypes.object,
}

Checkbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
}

export default TeamForm
